import React from 'react'
import TechDashboardComponent from '../components/TechDashboard'

function TechDashboard() {
  return (
    <div>
      <TechDashboardComponent />
    </div>
  )
}

export default TechDashboard